// extracted by mini-css-extract-plugin
export default {"title":"_1f061c6f60","bld":"_6d39a79524"};